import React from 'react';
import Paper from "@material-ui/core/Paper";
import {withStyles} from "@material-ui/styles";
import {NotificationManager, NotificationContainer} from "react-notifications";
import TableComponent from "../common/TableComponent";
import {AddCircleTwoTone, SystemUpdateAltTwoTone} from "@material-ui/icons";
import { t } from '../../i18n';

import TextField from "@material-ui/core/TextField";
import {GreenButton, OrangeButton} from "../common/ButtonsConstants";
import {
    deleteObjectives,
    objectives,
    saveOrUpdateObjectives
} from "../../util/ApiUtils";
import Typography from "@material-ui/core/Typography";
import {Spinner} from "../common/Spinner";
import {exportReport} from "../../util/ApiUtils";
import * as CommonUtils from "../../util/CommonUtils";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import TableCell from "@material-ui/core/TableCell";

const classes = (() => ({
    root: {
        width: '100%',
        overflowX: 'auto',
    },
    table: {
        minWidth: 650,
    },
    'input': {
    '&::placeholder': {
        textOverflow: 'ellipsis !important',
        background: 'yellow'
    }
},
}));

const columns = [
    { name: t('context.objectives.columns.objective'), id: 'objective', type: 'text' },
    { name: t('context.objectives.columns.target'), id: 'target', type: 'text' },
    { name: t('context.objectives.columns.isTargetMet'), id: 'isTargetMet', type: 'boolean' },
    { name: t('context.objectives.columns.comments'), id: 'comments', type: 'text' },
];

class Objectives extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            objectives: [],
            id: null,
            isLoading: true,
            isEditing: false,
            show: false,
            identifier: "",
            objective: "",
            target: "",
            isTargetMet: "",
            comments: "",
        };
        this.loadObjectives = this.loadObjectives.bind(this);
        this.handleAddRow = this.handleAddRow.bind(this);
        this.onSave = this.onSave.bind(this);
        this.onCancel = this.onCancel.bind(this);
        this.handleTextChange = this.handleTextChange.bind(this);
        this.onDelete = this.onDelete.bind(this);
        this.onEdit = this.onEdit.bind(this);
    }

    componentDidMount() {
        this.loadObjectives();
    }

    loadObjectives() {
        objectives()
            .then(response => {
                console.log('review', response);
                this.setState({
                    objectives: response,
                    isLoading: false,
                });
            })
            .catch(error => {
                console.log(error);
            });
    }

    onEdit(objective) {
        this.setState({
            isEditing: true,
            isLoading: false,
            isNew: false,
            id: objective.id,
            header: `${objective.objective}`,
            objective: `${objective.objective}`,
            target: `${objective.target}`,
            isTargetMet: `${objective.isTargetMet}`,
            comments: `${objective.comments}`,
        });
    }

    handleAddRow() {
        this.setState({
            isEditing: true,
            isLoading: false,
            isNew: true,
            id: null,
            identifier: "",
            objective: "",
            target: "",
            isTargetMet: "",
            comments: "",
            header: t('context.objectives.newRecord'),
        })
    }

    reset() {
        this.setState({
            isEditing: false,
            isLoading: true,
            isNew: true,
            id: null,
            identifier: "",
            objective: "",
            target: "",
            isTargetMet: "",
            comments: "",
            header: t('context.objectives.newRecord'),
        });
        this.loadObjectives();
    }

    onCancel() {
        this.reset();
    }

    onDelete(record) {
        deleteObjectives(record)
            .then(() => {
                NotificationManager.success(t('app.notifications.success'), t('context.objectives.removedSuccess'), 5000);
                this.reset();
            }).catch(error => {
            NotificationManager.error(t('app.notifications.error'), t('context.objectives.error'), 5000);
        });
    }

    onSave(event) {
        event.preventDefault();
        saveOrUpdateObjectives(this.state)
        .then((updatedRecord) => {
            NotificationManager.success(t('app.notifications.success'), t('context.objectives.updatedSuccess'), 5000);
            this.reset();
        }).catch(error => {
            console.log("error");
            console.log(error);
            NotificationManager.error(t('app.notifications.error'), t('context.objectives.error'), 5000);
        });
    }

    handleTextChange({ target }) {
        this.setState({
            ...this.state, [target.name]: target.value
        });
    }

    render() {
        let { state } = this;
        let { classes } = this.props;
        if (state.isLoading) {
            return <Spinner/>;
        }
        let isDemo = this.props.currentUser && this.props.currentUser.isDemo;
        let isAuditor = CommonUtils.isAuditor(this.props.currentUser);
        let isViewer = CommonUtils.isViewer(this.props.currentUser);
        return <div>
            <Typography component="h2" variant="h5">
                {t('context.objectives.title')}
            </Typography>
            <Paper className={classes.root} style={{ marginTop: '30px' }}>
                {(!state.isEditing ?
                        <div>
                            {!isDemo && !isViewer && <GreenButton startIcon={<SystemUpdateAltTwoTone/>} onClick={() => exportReport('/objectives/export')} style={{ float: 'right', marginRight: "160px" }}>{t('context.objectives.export')}</GreenButton>}
                            <TableComponent
                                tableKey="objectivesTable"
                                data={state.objectives}
                                columns={columns}
                                handleSubmit={this.handleSubmit}
                                handleAddRow={this.handleAddRow}
                                handleRowDel={this.onDelete}
                                handleRowEdit={this.onEdit}
                                allowAdd={(!isAuditor && !isViewer) ? 'show' : 'disable'}
                                allowUpdateDelete={(isAuditor || isViewer) ? 'no' : 'yes'}
                                pagination={true}
                            />
                        </div>
                        :
                        <div style={{ paddingLeft: "30px", paddingRight: "30px",  paddingBottom: "30px"}}>
                            <div>
                                <TextField
                                    name="objective"
                                    value={state.objective}
                                    onChange={(e) => this.handleTextChange(e)}
                                    label={t('context.objectives.labels.objective')}
                                    multiline
                                    rows="4"
                                    style={{width: "400px"}}
                                />
                            </div>
                            <div style={{ paddingTop: "20px"}}>
                                <TextField
                                    name={"target"}
                                    value={state.target}
                                    onChange={(e) => this.handleTextChange(e)}
                                    label={t('context.objectives.labels.target')}
                                    multiline
                                    rows="4"
                                    style={{width: "400px"}}
                                />
                            </div>
                            <div style={{ paddingTop: "30px"}}>
                                <FormControl className={classes.formControl}>
                                    <label htmlFor="isTargetMet">{t('context.objectives.labels.isTargetMet')}</label>
                                    <Select
                                        labelId="isTargetMet"
                                        id="isTargetMet"
                                        value={state.isTargetMet}
                                        name="isTargetMet"
                                        onChange={(e) => this.handleTextChange(e)}
                                    >
                                        <MenuItem value="true">{t('common.yes')}</MenuItem>
                                        <MenuItem value="false">{t('common.no')}</MenuItem>
                                    </Select>
                                </FormControl>
                            </div>
                            <div style={{ paddingTop: "20px"}}>
                                <TextField
                                    name="comments"
                                    value={state.comments}
                                    onChange={(e) => this.handleTextChange(e)}
                                    label={t('context.objectives.labels.comments')}
                                    multiline
                                    rows="4"
                                    style={{width: "400px"}}
                                />
                            </div>
                            <div style={{ width: "800px", clear: "both", paddingTop: "30px" }}>
                                <OrangeButton
                                     variant="contained"
                                     color="secondary"
                                     startIcon={<AddCircleTwoTone />}
                                     size="small"
                                     onClick={this.onCancel}
                                     style={{ marginTop: '20px', marginBottom: '20px', marginRight: '20px' , float: "left" }}
                                 >
                                    {t('context.objectives.cancel')}
                                 </OrangeButton>
                                 <GreenButton
                                     variant="contained"
                                     color="secondary"
                                     startIcon={<AddCircleTwoTone />}
                                     size="small"
                                     onClick={this.onSave}
                                     style={{ marginTop: '20px', marginBottom: '20px', float: "left" }}
                                 >
                                    {t('context.objectives.save')}
                                 </GreenButton>
                            </div>
                        </div>
                )}
            </Paper>
            <NotificationContainer/>
        </div>;
     }
 }

 export default withStyles(classes)(Objectives);
